import { resolveApiUrl } from "~/utils/url/urlResolver";
import { downloadBlobFromResponse, getCsrfValue } from "~/api/ApiHelper";
import { type UnitMode } from "~/ImperialMetricData/redux/UnitMode";

export const downloadPC = async (type: "PDF" | "XLSX", unitMode: UnitMode) => {
  const url = resolveApiUrl(`/product-comparison/download`);

  const response = await fetch(url, {
    body: JSON.stringify({ type, unit: unitMode }),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
  await downloadBlobFromResponse(response);
};
